import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const FINLAND_DATABASE_COUNTRY_ID = 4;

export const FinlandCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.FINLAND,
  languageCode: ELanguageCode.FINNISH,
  country: ECountry.FINLAND,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+358 99 999 9?9 999",
    placeholder: "+358 99 (9)999 9999",
    prefix: "+358",
  },
  databaseCountryId: FINLAND_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
